export default __webpack_public_path__ + "static/media/pvn-panfletos.3a5fc045.webp";